import { render, staticRenderFns } from "./TransitionCollapseHeight.vue?vue&type=template&id=72b2c742&scoped=true&"
import script from "./TransitionCollapseHeight.vue?vue&type=script&lang=js&"
export * from "./TransitionCollapseHeight.vue?vue&type=script&lang=js&"
import style0 from "./TransitionCollapseHeight.vue?vue&type=style&index=0&id=72b2c742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2c742",
  null
  
)

export default component.exports